import React, { Fragment, useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  TextField,
  Divider,
  Grid,
  InputAdornment,
  IconButton,
  Stack,
} from "@mui/material";
import { Paper, Link, Box } from "@material-ui/core";
import { SignInLogo } from "../../components/utils/SignInLogo";
import UserProfileModal from "../pages/modals/UserProfileModal";
import PromptModal from "../pages/modals/PromptModal";
import { signIn, forgotPassword, verifyOTP } from "../../apis/UserManagement";
import test from "../../assets/signin_img.png";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="/umingan">
        CBEWS-L
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const Signin = () => {
  const [openModal, setOpenModal] = useState(false);
  const [inputOTPModal, setInputOTPModal] = useState(false);
  const [createAccountModal, setCreateAccountModal] = useState(false);

  const [openPrompt, setOpenPrompt] = useState(false);
  const [promptTitle, setPromptTitle] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [errorPrompt, setErrorPrompt] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMatched, setPasswordMatched] = useState();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [indicator, setIndicator] = useState("");
  const [otp, setOTP] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  let navigate = useNavigate();
  useEffect(() => {
    checkMatch();
  }, [newPassword, confirmPassword]);

  const checkMatch = () => {
    if (confirmPassword != "") {
      if (newPassword == confirmPassword) setPasswordMatched(true);
      else setPasswordMatched(false);
    } else setPasswordMatched(true);
  };

  const handleLogin = () => {
    let submitData = {
      username: username,
      password: password,
    };

    if (username != "" && password != "") {
      signIn(submitData, (response) => {
        if (response.status == true) {
          let temp = { ...response.data };
          console.log(process.env.REACT_APP_SITE);
          if (temp.profile.site_id !== parseInt(process.env.REACT_APP_SITE)) {
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: "This account is not allowed in this web application",
              confirmButtonColor: "#1976d2"
            });
          } else {
            localStorage.setItem("umi_credentials", JSON.stringify(temp));
            window.location = `/opcen`;
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: response.message,
            confirmButtonColor: "#1976d2"
          });
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Username / Password not found",
        confirmButtonColor: "#1976d2"
      });
    }
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        fullScreen={false}
        maxWidth="xs"
        open={openModal}
        aria-labelledby="form-dialog-title"
        style={{ zIndex: 1059 }}
      >
        <DialogTitle id="form-dialog-title">Forgot Password</DialogTitle>
        <DialogContent>
          <TextField
            id="filled-helperText"
            placeholder="E.g. JuanDelacruz"
            // inputProps={{min: 0, style: {textAlign: 'center'}}}
            helperText={
              <Typography
                variant="caption"
                display="block"
                // style={{textAlign: 'center'}}
              >
                Username or Mobile Number
              </Typography>
            }
            variant="outlined"
            style={{ width: "100%" }}
            onChange={(e) => {
              setIndicator(e.target.value);
            }}
          />

          <Link
            component="button"
            onClick={(e) => {
              setOpenModal(false);
              setInputOTPModal(true);
            }}
            style={{ width: "100%", fontSize: 15 }}
          >
            Already have an OTP? Click here.
          </Link>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={(e) => {
              forgotPassword({ indicator: indicator }, (response) => {
                console.log(response);
                if (response.status == true) {
                  Swal.fire({
                    icon: "info",
                    title: "OTP sent!",
                    text: response.message,
                    confirmButtonColor: "#1976d2"
                  });
                  setOpenModal(false);
                } else {
                  Swal.fire({
                    icon: "error",
                    title: "Error!",
                    text: response.message,
                    confirmButtonColor: "#1976d2"
                  });
                }
              });
            }}
          >
            Request OTP
          </Button>
          <Button
            color="secondary"
            onClick={(e) => {
              setOpenModal(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        fullScreen={false}
        maxWidth="xs"
        open={inputOTPModal}
        aria-labelledby="form-dialog-title"
        style={{ zIndex: 1059 }}
      >
        <DialogTitle id="form-dialog-title">Create New Password</DialogTitle>
        <DialogContent style={{ paddingTop: 10 }}>
          <TextField
            id="filled-helperText"
            label="OTP"
            placeholder="XXXX"
            helperText="Ask developers for your OTP"
            variant="outlined"
            style={{ width: "100%", paddingBottom: 10 }}
            onChange={(e) => {
              setOTP(e.target.value);
            }}
          />

          <TextField
            // error={passwordMatched ? false : true}
            // helperText={passwordMatched ? " " : "Password does not match"}
            id="outlined-required"
            placeholder="XXXX"
            type={showNewPassword ? "text" : "password"}
            label="New Password"
            variant="outlined"
            style={{ width: "100%", paddingBottom: 10 }}
            onChange={(e) => {
              setNewPassword(e.target.value);
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => {
                      setShowNewPassword(!showNewPassword);
                    }}
                    onMouseDown={() => {}}
                    edge="end"
                  >
                    {showNewPassword ? (
                      <VisibilityIcon />
                    ) : (
                      <VisibilityOffIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            error={passwordMatched ? false : true}
            helperText={passwordMatched ? " " : "Password does not match"}
            id="outlined-required"
            placeholder="XXXX"
            type={showConfirmPassword ? "text" : "password"}
            label="Confirm Password"
            variant="outlined"
            style={{ width: "100%" }}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => {
                      setShowConfirmPassword(!showConfirmPassword);
                    }}
                    onMouseDown={() => {}}
                    edge="end"
                  >
                    {showConfirmPassword ? (
                      <VisibilityIcon />
                    ) : (
                      <VisibilityOffIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            disabled={passwordMatched && confirmPassword != "" ? false : true}
            onClick={(e) => {
              console.log("pinapasa", password);
              verifyOTP({ password: newPassword, otp: otp }, (response) => {
                console.log(response);
                if (response.status == true) {
                  Swal.fire({
                    icon: "success",
                    title: response.title,
                    text: response.message,
                    confirmButtonColor: "#1976d2"
                  });
                  setInputOTPModal(false);
                } else {
                  Swal.fire({
                    icon: "error",
                    title: response.title,
                    text: response.message,
                    confirmButtonColor: "#1976d2"
                  });
                }
              });
            }}
          >
            Submit
          </Button>
          <Button
            color="secondary"
            onClick={(e) => {
              setInputOTPModal(false);
              setOpenModal(true);
            }}
          >
            Back
          </Button>
        </DialogActions>
      </Dialog>

      <UserProfileModal
        isOpen={createAccountModal}
        setIsOpen={setCreateAccountModal}
      />

      <PromptModal
        isOpen={openPrompt}
        error={errorPrompt}
        setOpenModal={setOpenPrompt}
        notifMessage={notifMessage}
        title={promptTitle}
      />
      <Grid
        style={{
          backgroundImage: `url(${test})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100%",
        }}
      >
        <Grid container justifyContent="center" marginTop="5%">
          <Grid
            item
            xs={12}
            sm={12}
            md={7}
            elevation={6}
            alignContents="center"
          >
            <SignInLogo />

            <Typography
              component="h2"
              variant="h2"
              style={{
                textAlign: "center",
                color: "#2E2D77",
                fontFamily: "Times New Roman",
                paddingBottom: "5%",
              }}
            >
              Community-based Early Warning Systems for Landslides
            </Typography>
            <Grid container spacing={4} textAlign="center">
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  id="filled-helperText"
                  placeholder="E.g. JuanDelacruz"
                  inputProps={{ min: 0, style: { textAlign: "center" } }}
                  helperText={
                    <Typography
                      variant="caption"
                      display="block"
                      style={{ textAlign: "center" }}
                    >
                      Username
                    </Typography>
                  }
                  variant="outlined"
                  sx={{ fieldset: { borderColor: "#2E2D77" } }}
                  style={{ width: "50%" }}
                  onChange={(e) => {
                    setUsername(e.target.value);
                  }}
                  onKeyPress={(event) => {
                    if (event.code === "Enter") {
                      handleLogin();
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  id="filled-helperText"
                  placeholder="**************"
                  inputProps={{ min: 0, style: { textAlign: "center" } }}
                  type={showPassword ? "text" : "password"}
                  helperText={
                    <Typography
                      variant="caption"
                      display="block"
                      style={{ textAlign: "center" }}
                    >
                      Password
                    </Typography>
                  }
                  variant="outlined"
                  sx={{ fieldset: { borderColor: "#2E2D77" } }}
                  style={{ width: "50%" }}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          onMouseDown={() => {}}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onKeyPress={(event) => {
                    if (event.code === "Enter") {
                      if (event.code === "Enter") {
                        handleLogin();
                      }
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#2E2D77" }}
                  onClick={() => {
                    // window.location = `/opcen`;
                    handleLogin();
                  }}
                >
                  Sign in
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={12} style={{ marginBottom: 15 }}>
              <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  justifyContent="center"
                  alignItems="center"
                  // mt={3}
                  >
                <Grid>
                  <Link
                    component="button"
                    style={{
                      fontStyle: "italic",
                      fontSize: 16,
                      color: "#2E2D77",
                    }}
                    onClick={(e) => {
                      setOpenModal(true);
                    }}
                  >
                    Forgot Password?
                  </Link>
                </Grid>
                <Grid>
                  <Link
                    component="button"
                    style={{
                      fontStyle: "italic",
                      fontSize: 16,
                      color: "#2E2D77",
                    }}
                    onClick={(e) => {
                      setCreateAccountModal(true);
                    }}
                  >
                    No account yet? Register here!
                  </Link>
                  
                </Grid>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Signin;
